import React from 'react'
import { useSelector } from 'react-redux'

import { DatepickerHeader } from '~/components/datepicker-header'
import EmptyPage from '~/components/empty-page'
import { FiltersMetabase } from '~/components/FiltersMetabase'
import HeaderPages from '~/components/HeaderPages'
import MetabaseDashboard from '~/components/MetabaseDashboard'

import { Container } from './styles'

const SellouttCustomerDashboard = () => {
  const { supermarkets: filteredSupermarketsIds } = useSelector(
    state => state.filtersSellOut
  )

  return (
    <Container>
      <HeaderPages
        title="Relatório de consumidores"
        sideRightComponent={<DatepickerHeader maxEndDate="D1" />}
      />

      <FiltersMetabase />

      {filteredSupermarketsIds && <MetabaseDashboard type="customersGrocery" />}

      {!filteredSupermarketsIds && (
        <EmptyPage
          title="Selecione um supermercado"
          subtitle="Para começar precisamos definir um supermercado."
          svgPath="photos/orders-empty"
        />
      )}
    </Container>
  )
}

export default SellouttCustomerDashboard
